import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BASE_URL}/api`;


// Devuelve 1 registro
export const getByClaveProyecto = async (claveProyecto = '') => {

    const respuesta = { exito: 0, mensaje: '', data: [] };
    const url = `${ baseUrl }/EventosConRegistro`;

    await axios.get(url)
        .then((response) => {
            const responseData = response.data;
            respuesta.data = responseData.data.filter(rd => rd.claveProyecto === claveProyecto);
            respuesta.exito = 1;
        })
        .catch( 
            err => respuesta.mensaje = err
        );

    return respuesta;
}


export const getAllEventosConRegistro = async () => {

    const respuesta = { exito: 0, mensaje: '', data: [] };
    const url = `${ baseUrl }/EventosConRegistro`;

    await axios.get(url)
        .then((response) => {
            // const responseData = response.data;
            respuesta.data = response.data.data;
            respuesta.exito = 1;
        })
        .catch( 
            err => respuesta.mensaje = err
        );

    return respuesta;
}